import "../../components/tile-component/TileComponent.scss";
import OnboardingPortalAppIcon from './components/OnboardingPortalAppIcon';

const AppOnboardingPreviewCard = ({ data }: { data: any }) => {
    const { title, icon, subTitle, iconUrl } = data;

    return (
        <>
            <div className="card">
                <div className="tile-body">
                    <div className="tile-icon">
                        <OnboardingPortalAppIcon icon={icon} iconUrl={iconUrl} />
                    </div>
                    <div className="tile-text-wrapper">
                        <div className="tile-title">{title}</div>
                        <div className="tile-subtext">
                            {subTitle?.toUpperCase?.() ?? ""}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default AppOnboardingPreviewCard;
